import React from "react";

import { Badge, Callout, Card, Table, Tooltip } from "../../../Ui/index.jsx";
import { AdminTab } from "./adminShared.jsx";

// A permission is a page in the left nav; what you may do with it is four flags. So the model reads as a
// grid (pages down, create / read / update / delete across), not a list of invented codes.
function FlagMark({ page, action, has }) {
  if (!page.supports.includes(action)) return <span className="ds-muted" title={`${page.label} has no ${action}`}>·</span>;
  return has.includes(action)
    ? <span className="ds-text-success ds-strong" title={`${page.page} — ${action}`}>✓</span>
    : <span className="ds-muted" title={`${page.page} — no ${action}`}>–</span>;
}

function PageGrid({ grid, pages, actions, emptyLabel }) {
  const held = pages.filter((p) => (grid[p.page] || []).length);
  if (!held.length) return <p className="ds-muted">{emptyLabel || "nothing"}</p>;
  const columns = [
    { key: "label", header: "Page", render: (p) => (
      <Tooltip content={p.note || p.label}>
        <span>
          {p.label}
          {p.self_service && <> <Badge title="Everyone gets this — it holds their own records">own</Badge></>}
        </span>
      </Tooltip>
    ) },
    ...actions.map((a) => ({
      key: a, header: <span title={a}>{a[0].toUpperCase()}</span>, align: "center",
      render: (p) => <FlagMark page={p} action={a} has={grid[p.page] || []} />,
    })),
  ];
  return <Table flush columns={columns} rows={held.map((p) => ({ ...p, id: p.page }))} />;
}

export function AccessModelTab({ matrix }) {
  if (!matrix) return null;
  const actions = matrix.actions || ["create", "read", "update", "delete"];
  const pages = matrix.pages || [];
  const grid = (g, emptyLabel) => <PageGrid grid={g} pages={pages} actions={actions} emptyLabel={emptyLabel} />;

  return (
    <AdminTab title="Access model" subtitle="page · create / read / update / delete">
      <p className="ds-muted">{matrix.page_rule}</p>
      <div className="ds-grid">
        <Card title="Everyone" subtitle="any department, including interns">{grid(matrix.everyone || {})}</Card>
        <Card title="Every full-timer" subtitle="any department">{grid(matrix.everyone_full_time || {})}</Card>
        {(matrix.page_families || []).map((f) => (
          <Card key={f.family} title={f.label || f.family} subtitle={f.departments.join(" · ") || "—"}>
            <div className="Adm-FamRow"><span className="ds-label">Juniors</span>{grid(f.intern, "everyone-baseline only")}</div>
            <div className="Adm-FamRow"><span className="ds-label">Full-time</span>{grid(f.full_time, "everyone-baseline only")}</div>
          </Card>
        ))}
      </div>
      <Callout soft>
        A page with no tick anywhere is not visible to that seat at all, and its
        endpoints refuse the request — not only in the menu, but to anything calling
        the API. A dot means the page has no such button to grant.
      </Callout>
    </AdminTab>
  );
}
